<template>
  <div class="retrieveLoginId" data-qa="confirmexit-div-qz21yr">
    <Modal :config="modalConfig" />
  </div>
</template>

<script>
export default {
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  props: {
    title: String,
    text: String
  },
  data () {
    return {
      modalConfig: {
        enabled: true,
        persistent: true,
        persist: true,
        btn2Label: this.$t('common.no'), // No Button
        btn1Label: this.$t('common.yes'), // Yes Button
        width: 450,
        cancelCallback: this.onOkClick, // Onclick of 'Yes' Button
        saveCallback: this.onCancelClick // Onclick of 'No' Button
      }
    }
  },
  methods: {
    onCancelClick () {
      this.$emit('isNotLeavingRoute')
    },
    onOkClick () {
      this.$emit('isLeavingRoute')
    }
  },
  created () {
    this.modalConfig.title = this.title || this.$t('common.confirmExitHeader')
    this.modalConfig.subtitle = this.text || this.$t('common.confirmExit')
  }
}
</script>
